import { render } from "./service_detail.vue?vue&type=template&id=792ae473"
import script from "./service_detail.vue?vue&type=script&lang=js"
export * from "./service_detail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__